import { Project } from './project'

export enum MARKER_TYPE {
  MARK = 'MARK',
  ROUND = 'ROUND',
}

export interface Position {
  left: number
  top: number
}

export interface Size {
  width: number
  height: number
}

type MarkerSize = { [key in MARKER_TYPE]: { [key in Project]: Size } }

export const markerSize: MarkerSize = {
  MARK: {
    mobile: {
      width: 32,
      height: 40,
    },
    pc: {
      width: 26,
      height: 26,
    },
  },
  ROUND: {
    mobile: {
      width: 12,
      height: 12,
    },
    pc: {
      width: 12,
      height: 12,
    },
  },
}

type MarkTypeLimit = { [key in Project]: number }

const markTypeLimit: MarkTypeLimit = {
  mobile: 3,
  pc: 5,
}

export interface MapLocation {
  latitude: number
  longitude: number
}

export const getMarkerSize = (type: MARKER_TYPE): Size => {
  return markerSize[type] && markerSize[type][process.env.PROJECT_NAME]
}

export const getMarkTypeLimit = (): number => {
  return markTypeLimit[process.env.PROJECT_NAME]
}
